import { render, staticRenderFns } from "./SubLicenseList.vue?vue&type=template&id=1e494a7c"
import script from "./SubLicenseList.vue?vue&type=script&lang=js"
export * from "./SubLicenseList.vue?vue&type=script&lang=js"
import style0 from "./SubLicenseList.vue?vue&type=style&index=0&id=1e494a7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports